import { apiCaller } from "./API";

export const queryLogs = (query, callback) => {
  apiCaller
    .post(`/log-fetch/v1/fetch/query`, query)
    .then((d) => callback(d.data))
    .catch((err) => console.error("Error", err));
};